import { COMPANY_PLACEHOLDER } from 'modules/companies/consts'
import { CompanyNode } from 'modules/companies/types.graphql'
import React from 'react'

export const CompanyContext =
  React.createContext<CompanyNode>(COMPANY_PLACEHOLDER)
